module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hr-drive-included.3718f78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fundamentals/fullscreen-image_hr-drive-included.png
// module id = VaRH
// module chunks = 0